import {
  FieldTypeFactory,
  ComponentTypeFactory,
} from '@sentecacommerce-theme/base'
import { SeoModuleProps } from './seomodule.props'

export const SeoModuleType = ComponentTypeFactory.create<SeoModuleProps>(
  'SeoModule',
  {
    title: FieldTypeFactory.text(),
    description: FieldTypeFactory.text(),
    keywords: FieldTypeFactory.text(),
    image: FieldTypeFactory.text(),
    noIndex: FieldTypeFactory.boolean({
      defaultValue: false,
      label: 'Disable robots to index the page',
    }),
  }
)
